import type { FaireProductEntity } from "../../entity_types/product";

export const p_eyuwvq9trd: FaireProductEntity = {
  token: "p_eyuwvq9trd",
  type: "product",
  name: "Stockist Display Sign - HI-FI",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/1297bb64414b566eab725386e3b611720b37ab8825709a55ec937b5630d2b4ce.png",
  galleryImageUrls: [],
  priceDollars: 1,
  description:
    'We now offer display signage + wood block for your P.F. Candle Co. display to educate your customers about our new HI-FI Collection!\n\nSign reads: \n\n"HI-FI by P.F. Candle Co.\n\nInspired by low-lit listening bars and ultra-chic hotel lounges, HI-FI is an olfactive expression of transportive sensory experiences and a meticulous attention to quality and atmosphere. \nMade in California by P.F. CANDLE CO., an independently owned and operated home fragrance company.  \n\nQuality Fragrance For Your Atmosphere"\n',
  tags: [],
  msrpDollars: 2,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T21:36:02.189Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
